module.exports = __webpack_public_path__ + "images/category_lp/common/icon-japan-map_03172bdc94a16d9a83604186120583a9.png";